import { LocationsRepository } from '@/core/domain/locations/repositories/locations.respository';
import { FindLocationsUseCase } from '@/core/domain/locations/usecases/findLocations.usecase';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocationsImplRepository } from './locations-imp.respository';
import { FindSchedulesUseCase } from '@/core/domain/locations/usecases/findSchedules.usecase';

const finsLocationsUseCaseFactory = (
    locationsRepository: LocationsRepository,
) => new FindLocationsUseCase(locationsRepository);

const finsSchedulesUseCaseFactory = (
    locationsRepository: LocationsRepository,
) => new FindSchedulesUseCase(locationsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: FindLocationsUseCase,
            useFactory: finsLocationsUseCaseFactory,
            deps: [LocationsImplRepository],
        },
        {
            provide: FindSchedulesUseCase,
            useFactory: finsSchedulesUseCaseFactory,
            deps: [LocationsImplRepository],
        },
        {
            provide: LocationsRepository,
            useClass: LocationsImplRepository,
        },
    ],
})
export class LocationsModule {}
